import {useSyncFavicon, useSyncMergeQueueFavicon} from '../../hooks/use-sync-favicon'
import type {StatusRollup} from '../../page-data/payloads/status-checks'
import {useSidebarMergeData} from './use-sidebar-merge-data'

export function SidebarFaviconSync() {
  const {mergeBoxPullRequest, statusChecksData} = useSidebarMergeData()

  if (mergeBoxPullRequest?.mergeQueueEntry) {
    return <SyncMergeQueueFavicon />
  }

  if (!statusChecksData) {
    return null
  }

  return <SyncChecksFavicon statusRollup={statusChecksData.statusRollup} />
}

function SyncMergeQueueFavicon() {
  useSyncMergeQueueFavicon()

  return null
}

function SyncChecksFavicon({statusRollup}: {statusRollup: StatusRollup}) {
  useSyncFavicon(statusRollup)

  return null
}
